import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { DepartmentReportStatusSummary } from "@features/report/tag/types/departmentReportStatusSummary";
import {
    StatusCountMode,
    formatScopeStatusCounts,
} from "@features/report/tag/utils/departmentReportStatusCounts";

type Props = {
    summary: DepartmentReportStatusSummary;
    mode: StatusCountMode;
    combinedLine: string;
};

const DepartmentReportStatusCountBreakdown: React.FC<Props> = ({
    summary,
    mode,
    combinedLine,
}) => {
    const [expanded, setExpanded] = useState(false);
    const scopeRows = formatScopeStatusCounts(summary.counts_by_scope, mode);

    return (
        <div>
            <p className="mb-2">{combinedLine}</p>
            {scopeRows.length > 0 && (
                <>
                    <Button
                        variant="link"
                        className="p-0 mb-2"
                        onClick={() => setExpanded((v) => !v)}
                        aria-expanded={expanded}
                    >
                        {expanded ? "Hide breakdown" : "View breakdown by level"}
                    </Button>
                    {expanded && (
                        <ul className="mb-0 ps-3">
                            {scopeRows.map((row) => (
                                <li key={row.scope}>
                                    {row.label}: {row.line}
                                </li>
                            ))}
                        </ul>
                    )}
                </>
            )}
        </div>
    );
};

export default DepartmentReportStatusCountBreakdown;
